module.exports = __webpack_public_path__ + "ff8379080dcebe47cda2ad884eafed02.svg";